import {Card} from '@ezcater/tapas';
import {twMerge} from 'tailwind-merge';

import Carousel, {CarouselCard} from '@/components/ui/Carousel';
import {
  CARD_BASIS_CLASSNAMES,
  CARD_PADDING_CLASSNAMES,
  SLIDE_CONTAINER_CLASSNAMES,
} from './carouselClassNames';

const SKELETON_CARD_COUNT = 2;

type JumpBackInHomepageSkeletonProps = {
  isCollectionOfFiltersVisible?: boolean;
  inValuePropsTreatment?: boolean; // ezx579::ARC::ValueProps
};

const JumpBackInHomepageSkeleton: React.FC<JumpBackInHomepageSkeletonProps> = ({
  inValuePropsTreatment, // ezx579::ARC::ValueProps
}) => (
  <section
    aria-hidden
    className={twMerge(
      'mx-auto w-full max-w-[1296px] px-4 pt-12 tablet:-mb-4 tablet:px-6',
      inValuePropsTreatment ? 'pt-[8.25rem] desktop:pt-[5.625rem]' : '', // ezx579::ARC::ValueProps
    )}

    data-testid="jump-back-in-homepage-skeleton"
  >
    <div className="ml-2 h-8 w-56 animate-pulse rounded bg-peppercorn-200" />

    <Carousel
      hideControls
      slotProps={{
        slideContainer: {className: SLIDE_CONTAINER_CLASSNAMES},
      }}
    >
      {Array.from({length: SKELETON_CARD_COUNT}).map((_, i) => (
        <CarouselCard
          basisClassNames={CARD_BASIS_CLASSNAMES}
          className={CARD_PADDING_CLASSNAMES}
          key={`jump-back-in-skeleton-${i}`}
        >
          <Card className="flex animate-pulse flex-col gap-3 p-4 tablet:flex-row tablet:items-center tablet:justify-between tablet:gap-4 tablet:p-5">
            <div className="h-[180px] w-full shrink-0 rounded-2xl bg-peppercorn-200 tablet:order-last tablet:h-[125px] tablet:w-[125px]" />
            <div className="flex flex-1 flex-col gap-3">
              <div className="h-6 w-4/5 rounded bg-peppercorn-200" />
              <div className="h-4 w-3/5 rounded bg-peppercorn-200" />
              <div className="h-4 w-1/2 rounded bg-peppercorn-200" />
              <div className="h-4 w-2/3 rounded bg-peppercorn-200" />
            </div>
          </Card>
        </CarouselCard>
      ))}
    </Carousel>
  </section>
);

export default JumpBackInHomepageSkeleton;
